import { POST, GET } from './utils';

export const GET_FORM_DATA = ({ cardId, boardId, formId }) =>
  GET({ url: `forms/${formId}/${cardId}/${boardId}` });

export const SUBMIT_FORM_DATA = ({ data }) => POST({ url: 'forms/submit', data });

export const SEARCH_LOCATIONS = ({ data }) => POST({ url: 'forms/searchLocations', data });
